import React, { useState, useEffect } from 'react';
import ReactSlider from 'react-slider';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetVendorsQuery } from '../../app/config/redux/slices/api/vendorApiSlice';

const ProductFiltering = ({ onApplyFilters, setQuantity, sidebarController, active }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const productCategories = useSelector(
    (state) => state.api.queries?.['getProductCategories(undefined)']?.data
  );
  

  const { data, isLoading, error } = useGetVendorsQuery();
  const vendors = data?.data ?? [];

  const [outOfStock, setOutOfStock] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 10000]);

  // Get initial state from URL
  const [selectedCategory, setSelectedCategory] = useState(searchParams.get('category') || null);
  const [selectedVendor, setVendor] = useState(searchParams.get('vendor') || null);

  // Update from URL when search params change
  useEffect(() => {
    const vendorParam = searchParams.get('vendor');
    const categoryParam = searchParams.get('category');

    setVendor(vendorParam || null);
    setSelectedCategory(categoryParam || null);
  }, [searchParams]);

  // Apply filters whenever selection changes
  useEffect(() => {
    handleApplyFilters();
  }, [selectedCategory, selectedVendor, priceRange, outOfStock]);

  // --- CATEGORY FILTER ---
  const handleCategoryChange = (categoryId) => {
    if (!categoryId) {
      setSelectedCategory(null);
      searchParams.delete('category');
    } else {
      setSelectedCategory(categoryId);
      searchParams.set('category', categoryId);
    }
    setSearchParams(searchParams);
  };

  // --- VENDOR FILTER ---
  const handleVendorChange = (vendorId) => {
    if (!vendorId) {
      setVendor(null);
      searchParams.delete('vendor');
    } else {
      setVendor(vendorId);
      searchParams.set('vendor', vendorId);
    }
    setSearchParams(searchParams);
  };

  // --- OUT OF STOCK ---
  const handleOutOfStockChange = (value) => {
    setOutOfStock(value);
    setQuantity(value ? 0 : 1);
  };

  // --- APPLY FILTERS ---
  const handleApplyFilters = () => {
    const newFilters = {
      price: {
        operation: 'bw',
        value: priceRange[0],
        limitValue: priceRange[1],
      },
    };

    if (selectedCategory) {
      newFilters.category = { value: selectedCategory, operation: 'e' };
    }
    if (selectedVendor) {
      newFilters.vendor = { value: selectedVendor, operation: 'e' };
    }

    onApplyFilters(newFilters);
  };

  return (
    <div className="col-lg-3">
      <div className={`shop-sidebar ${active && 'active'}`}>
        <button
          onClick={sidebarController}
          type="button"
          className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
        >
          <i className="ph ph-x" />
        </button>

        {/* Product Category */}
        <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
          <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">Product Category</h6>
          <ul className="max-h-540 overflow-y-auto scroll-sm">
            <li key="all-categories" className="mb-24">
              <button
                className={`text-gray-900 hover-text-main-600 ${
                  !selectedCategory ? 'text-main-600 font-bold' : ''
                }`}
                onClick={() => handleCategoryChange(null)}
              >
                All Categories
              </button>
            </li>
            {productCategories?.map((category) => (
              <li key={category.id} className="mb-24">
                <button
                  className={`text-left w-full ${
                    selectedCategory === String(category.id)
                      ? 'text-main-600 font-bold'
                      : 'text-gray-900 hover:text-main-600'
                  }`}
                  onClick={() => handleCategoryChange(String(category.id))}
                >
                  {category.name.charAt(0).toUpperCase() + category.name.slice(1)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Filter by Price */}
        {/* <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
          <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">Filter by Price</h6>
          <div className="custom--range">
            <ReactSlider
              className="horizontal-slider"
              thumbClassName="example-thumb"
              trackClassName="example-track"
              value={priceRange}
              onChange={(value) => setPriceRange(value)}
              pearling
              minDistance={10}
              min={0}
              max={1000}
              renderThumb={(props, state) => (
                <div {...props} key={state.index}>
                  {state.valueNow}
                </div>
              )}
            />
            <div className="flex-between flex-wrap-reverse gap-8 mt-24">
              <button
                type="button"
                className="btn btn-main h-40 flex-align"
                onClick={handleApplyFilters}
              >
                Filter
              </button>
            </div>
          </div>
        </div> */}

        {/* Filter by Rating */}

        {/* <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
            <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                Filter by Rating
            </h6>
            <div className="flex-align gap-8 position-relative mb-20">
                <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating5"
                >
                    {" "}
                </label>
                <div className="common-check common-radio mb-0">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="rating5"
                    />
                </div>
                <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={70}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    <div
                        className="progress-bar bg-main-600 rounded-pill"
                        style={{ width: "70%" }}
                    />
                </div>
                <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                </div>
                <span className="text-gray-900 flex-shrink-0">124</span>
            </div>
            <div className="flex-align gap-8 position-relative mb-20">
                <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating4"
                >
                    {" "}
                </label>
                <div className="common-check common-radio mb-0">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="rating4"
                    />
                </div>
                <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={50}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    <div
                        className="progress-bar bg-main-600 rounded-pill"
                        style={{ width: "50%" }}
                    />
                </div>
                <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                </div>
                <span className="text-gray-900 flex-shrink-0">52</span>
            </div>
            <div className="flex-align gap-8 position-relative mb-20">
                <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating3"
                >
                    {" "}
                </label>
                <div className="common-check common-radio mb-0">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="rating3"
                    />
                </div>
                <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={35}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    <div
                        className="progress-bar bg-main-600 rounded-pill"
                        style={{ width: "35%" }}
                    />
                </div>
                <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                </div>
                <span className="text-gray-900 flex-shrink-0">12</span>
            </div>
            <div className="flex-align gap-8 position-relative mb-20">
                <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating2"
                >
                    {" "}
                </label>
                <div className="common-check common-radio mb-0">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="rating2"
                    />
                </div>
                <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={20}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    <div
                        className="progress-bar bg-main-600 rounded-pill"
                        style={{ width: "20%" }}
                    />
                </div>
                <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                </div>
                <span className="text-gray-900 flex-shrink-0">5</span>
            </div>
            <div className="flex-align gap-8 position-relative mb-0">
                <label
                    className="position-absolute w-100 h-100 cursor-pointer"
                    htmlFor="rating1"
                >
                    {" "}
                </label>
                <div className="common-check common-radio mb-0">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="rating1"
                    />
                </div>
                <div
                    className="progress w-100 bg-gray-100 rounded-pill h-8"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow={5}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    <div
                        className="progress-bar bg-main-600 rounded-pill"
                        style={{ width: "5%" }}
                    />
                </div>
                <div className="flex-align gap-4">
                    <span className="text-xs fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-400 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                </div>
                <span className="text-gray-900 flex-shrink-0">2</span>
            </div>
        </div> */}


        {/* Include Out of Stock */}
        <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
          <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">Include Out of Stock</h6>
          <ul className="max-h-540 overflow-y-auto scroll-sm">
            <li className="mb-24">
              <div className="form-check common-check common-radio checked-black">
                <input
                  className="form-check-input"
                  type="radio"
                  name="outOfStock"
                  id="includeOutOfStockYes"
                  checked={outOfStock === true}
                  onChange={() => handleOutOfStockChange(true)}
                />
                <label className="form-check-label" htmlFor="includeOutOfStockYes">
                  Yes
                </label>
              </div>
            </li>
            <li className="mb-24">
              <div className="form-check common-check common-radio checked-primary">
                <input
                  className="form-check-input"
                  type="radio"
                  name="outOfStock"
                  id="includeOutOfStockNo"
                  checked={outOfStock === false}
                  onChange={() => handleOutOfStockChange(false)}
                />
                <label className="form-check-label" htmlFor="includeOutOfStockNo">
                  No
                </label>
              </div>
            </li>
          </ul>
        </div>

        {/* Filter by Vendor */}
        <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
          <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">Filter by Brand</h6>
          <ul className="max-h-540 overflow-y-auto scroll-sm">
            <li key="all-vendors" className="mb-24">
              <div className="form-check common-check common-radio">
                <input
                  className="form-check-input"
                  type="radio"
                  name="vendor"
                  id="allVendor"
                  checked={!selectedVendor}
                  onChange={() => handleVendorChange(null)}
                />
                <label className="form-check-label" htmlFor="allVendor">
                  All Vendors
                </label>
              </div>
            </li>
            {vendors?.map((vendor) => (
              <li key={vendor.id} className="mb-24">
                <div className="form-check common-check common-radio">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="vendor"
                    id={`vendor-${vendor.id}`}
                    checked={selectedVendor === String(vendor.id)}
                    onChange={() => handleVendorChange(String(vendor.id))}
                  />
                  <label className="form-check-label" htmlFor={`vendor-${vendor.id}`}>
                    {vendor.name}
                  </label>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="shop-sidebar__box rounded-8">
          <img src="assets/images/style/advertise_img_1.png" alt="Ad" />
        </div>
      </div>
    </div>
  );
};

export default ProductFiltering;
